var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSlate } from "slate-react";
import { css } from "@emotion/css";
import { Button, Icon } from "../BaseComponents";
import { isBlockActive } from "../../plugins/helpers/isBlockActive";
import { toggleBlock } from "../../plugins/helpers/toggleBlock";
import { unwrapLink } from "../../plugins/helpers/unwrapLink";
import { isUrl } from "../../util/isUrl";
import Description from "../Description/Description";
var TEXT_ALIGN_TYPES = ["left", "center", "right", "justify"];
var BlockButton = function (_a) {
    var format = _a.format, icon = _a.icon, callback = _a.callback, description = _a.description, className = _a.className, setIsUnsplash = _a.setIsUnsplash, isUnsplash = _a.isUnsplash, selectUnsplashImage = _a.selectUnsplashImage;
    var editor = useSlate();
    return (_jsxs(Button, __assign({ className: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        position: relative;\n        &:hover {\n          .tag {\n            display: block;\n          }\n        }\n      "], ["\n        position: relative;\n        &:hover {\n          .tag {\n            display: block;\n          }\n        }\n      "]))), active: isBlockActive(editor, format, TEXT_ALIGN_TYPES.includes(format) ? "align" : "type"), onMouseDown: function (event) { return __awaiter(void 0, void 0, void 0, function () {
            var url, url, url, row, column;
            return __generator(this, function (_a) {
                event.preventDefault();
                if (icon === "link_off") {
                    if (isBlockActive(editor, "link")) {
                        return [2 /*return*/, unwrapLink(editor)];
                    }
                }
                if (format === "link") {
                    url = window.prompt("Enter the URL of the link:");
                    if (!url || !isUrl(url)) {
                        alert("Not a valid input!");
                        return [2 /*return*/];
                    }
                    return [2 /*return*/, toggleBlock(editor, format, url)];
                }
                if (format === "unsplash") {
                    setIsUnsplash === null || setIsUnsplash === void 0 ? void 0 : setIsUnsplash(!isUnsplash);
                }
                if (format === "video") {
                    url = window.prompt("Enter the URL of the image:");
                    if (!url) {
                        alert("Not a valid input!");
                        return [2 /*return*/];
                    }
                    return [2 /*return*/, toggleBlock(editor, format, url)];
                }
                if (format === "sub-title") {
                    return [2 /*return*/, toggleBlock(editor, format, "", callback)];
                }
                if (format === "embed") {
                    url = window.prompt("Enter the URL of the Instagram post:");
                    if (!url) {
                        alert("Not a valid input!");
                        return [2 /*return*/];
                    }
                    return [2 /*return*/, toggleBlock(editor, format, url)];
                }
                if (format === "table") {
                    row = window.prompt("Enter the row of the Table:");
                    column = window.prompt("Enter the column of the Table:");
                    if (!row || !column) {
                        alert("Not a valid input!");
                        return [2 /*return*/];
                    }
                    if (+row <= 1 || +column <= 1) {
                        alert("Row and Column must greater than 1!");
                        return [2 /*return*/];
                    }
                    return [2 /*return*/, toggleBlock(editor, format, "", callback, +row, +column)];
                }
                toggleBlock(editor, format); // 插入圖片會走這裡
                return [2 /*return*/];
            });
        }); } }, { children: [_jsx(Description, { description: description }), _jsx(Icon, __assign({ className: className }, { children: icon }))] })));
};
export default BlockButton;
var templateObject_1;
